import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, of} from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';

import { CookieService } from 'ngx-cookie-service';
import { BaseService } from './base.service';

@Injectable()
export class StaffActivityService extends BaseService {

    constructor(cookieService: CookieService,
                http: HttpClient) {
        super(cookieService, http);
    }

    getStaffActivity(weekEnding?: any): Observable<any> {
        //this.managerId = this.cookieService.get('mngrid');
        this.managerId = localStorage.getItem('mngrid');
        /*let httpParams = new HttpParams().set('ManagerKey', this.managerId);
        httpParams = httpParams.set('WeekEnding', weekEnding.toLocaleDateString().replace(/\//g, ''));*/

        let httpHeaders = new HttpHeaders();
        httpHeaders = httpHeaders.append('access-key', StaffActivityService.publicAccessKey);
        httpHeaders = httpHeaders.append('Content-Type', 'application/json');

        return this.http.get<any>(
            StaffActivityService.staffActivityGetUrl + '/GetByManagerKeyAndWeekEnding/' + this.managerId + '/' + weekEnding.toLocaleDateString().replace(/\//g, ''),
            { headers: httpHeaders}).pipe(
                map(data => data),
                tap(_ => this.log('Fetching staff in dynamo.')),
                catchError(this.handleError('getLoginResponse')),
          );
    }

    saveStaffActivity(dataToSave: any): Observable<any> {
        //const mngrid = this.cookieService.get('mngrid');
        const mngrid = localStorage.getItem('mngrid');

        const staffData = {
            StaffActivityId : dataToSave.staffActivityId,
            ManagerKey : Number(mngrid),
            OtherPeopleData : new Array(),
            StaffData : new Array(),
            WeekEnding : dataToSave.weekEnding
        };

        /*
        name: employee.fname + ' ' + employee.lname,
        comments: (staffUnit) ? staffUnit.Comments : '-',
        oneToOne: (staffUnit) ? (staffUnit.One2One && staffUnit.One2One === 'N') ? false : true : false,
        projects: (employee.projects) ? employee.projects : '-',
        gActivities: (staffUnit) ? (staffUnit.GroupActivities && staffUnit.GroupActivities === 'N') ? false : true : false,
        health: (staffUnit) ? staffUnit.Health : 100,
        performance: (staffUnit) ? staffUnit.Performance : 100,
        id: employee.id
        */
        if (dataToSave.employees) {
            dataToSave.employees.forEach(employee => {
                staffData.StaffData.push({
                    Comments : employee.comments,
                    GroupActivities : (employee.gActivities) ? 'Y' : 'N',
                    Health : employee.health,
                    One2One : (employee.oneToOne) ? 'Y' : 'N',
                    Performance : employee.performance,
                    Projects : employee.projects,
                    StaffKey : employee.id
                });
            });
        }

        if (dataToSave.otherStaff) {
            dataToSave.otherStaff.forEach(employee => {
                staffData.OtherPeopleData.push({
                    Comments : employee.comments,
                    GroupActivities : (employee.gActivities) ? 'Y' : 'N',
                    Health : employee.health,
                    One2One : (employee.oneToOne) ? 'Y' : 'N',
                    Performance : employee.performance,
                    Projects : employee.projects,
                    StaffKey : employee.id
                });
            });
        }

        if(!staffData.StaffActivityId){
            staffData.StaffActivityId = '00000000-0000-0000-0000-000000000000';
        }

        let httpHeaders = new HttpHeaders();
        httpHeaders = httpHeaders.append('access-key', StaffActivityService.publicAccessKey);
        httpHeaders = httpHeaders.append('Content-Type', 'application/json');

        return this.http.post<any>(
            StaffActivityService.staffActivityGetUrl + '/SaveStaffData', 
            staffData,
            { headers: httpHeaders}).pipe(
                map(data => data),
                tap(_ => this.log('Fetching staff in dynamo.')),
                catchError(this.handleError('getLoginResponse')),
          );
    }
}
